<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M20.1279 10.3208L13.6133 22.4301L12.2443 21.6304L18.7589 9.52112C19.5929 7.97074 19.4041 5.65333 16.9808 4.26615C14.3057 2.71577 12.5118 4.34775 11.8666 5.53909L5.651 17.1098L4.53376 19.1987C4.06169 20.08 4.56523 21.4672 5.57232 22.0547C6.73677 22.7238 8.24741 22.3321 8.67227 21.5325L8.87684 21.1408L14.7306 10.2881C15.4072 9.04785 15.061 8.85201 14.762 8.67249C14.2585 8.37874 13.991 8.28082 13.3773 9.40688L9.42759 16.7345L8.05858 15.9348L12.0083 8.60721C12.3544 7.97074 13.4087 6.01237 15.5331 7.23635C16.4458 7.7749 17.2955 8.86833 16.1153 11.0715L11.1743 20.2269L10.057 22.2995C9.16008 23.9641 6.65809 24.519 4.817 23.4582C2.97592 22.3974 2.26781 20.08 3.16475 18.4154L3.22769 18.3175L10.4976 4.75575C11.7093 2.51994 14.4945 0.953239 17.7518 2.84633C20.9619 4.70679 21.3711 8.0197 20.1279 10.3208Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
